import React from "react";
import { Navigate, Outlet, useLocation, useNavigationType } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function getDefaultAuthedPath() {
  return "/scribe";
}

function DefaultDirect() {
  const { loading, isAuthenticated } = useAuth();
  const location = useLocation();
  const navType = useNavigationType();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (isAuthenticated && location.pathname === "/") {
    return <Navigate to={getDefaultAuthedPath()} replace />;
  }

  if (isAuthenticated && navType !== "POP" && location.pathname !== "/") {
    return <Navigate to={getDefaultAuthedPath()} replace />;
  }

  return <Outlet />;
}

export default DefaultDirect;
